import { createFileRoute } from '@tanstack/react-router'

import { WarehouseTransferPage } from '@/components/WarehouseTransfer/WarehouseTransferPage'

export const Route = createFileRoute('/_app/operations/warehouse-transfer/')({
  component: WarehouseTransferPage,
})
